module.exports = __webpack_public_path__ + "img/userIcon.a246f30d.svg";